module.exports = __webpack_public_path__ + "img/logo-icon-12.afa5774c.png";